import { convert } from "@/libs/units";
import type { NumericPoint } from "@incytestudios/ddv";
import { isFinitePoint, isNaturalPoint } from "../_common";
import type { SinglePumpChartContext, DataSetWithOriginalPoints } from "..";
import { getPumpNpshr } from "@/libs/calculations/pumps/pumpData";

const getNPSHRPoints = (
  context: SinglePumpChartContext
): {
  originalPoints: NumericPoint[];
  convertedPoints: NumericPoint[];
} => {
  const {
    hypotheticals: { hypotheticalFlowRates },
    frequencyRatio,
    baseXUnit,
    targetXUnit,
    baseNpshYUnit,
    targetNpshYUnit,
    scenarioCalculations: { primaryPump }
  } = context;
  const originalPoints = hypotheticalFlowRates.map<NumericPoint>(flowRate => {
    return {
      x: flowRate,
      y: getPumpNpshr(primaryPump.value, flowRate, frequencyRatio)
    };
  });
  const convertedPoints = originalPoints
    .map(pt => ({
      x: convert(pt.x, baseXUnit, targetXUnit),
      y: convert(pt.y, baseNpshYUnit, targetNpshYUnit)
    }))
    .filter(isFinitePoint)
    .filter(isNaturalPoint);
  return { originalPoints, convertedPoints };
};

export const getDataSetNPSHR = (
  context: SinglePumpChartContext
): DataSetWithOriginalPoints => {
  const { targetXUnitLabel, targetNpshYUnitLabel } = context;
  const pointSets = getNPSHRPoints(context);

  return {
    title: "NPSHr",
    xAxisLabel: `Flow Rate (${targetXUnitLabel})`,
    yAxisLabel: `Head (${targetNpshYUnitLabel})`,
    points: pointSets.convertedPoints,
    originalPoints: pointSets.originalPoints
  };
};
